// React import
import * as React from 'react';
// Standard layout imports
import { connect } from 'react-redux';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import Switch from 'src/components/FormElements/Switch';
import { toggelShowUserInterest } from 'src/Entities/User/User.Actions';

interface IProps {
  label: string;
  doToggelUserIntrests: (val: boolean) => void;
  isChecked: boolean;
  userIntrests: string[];
}
class MyPageShowUserInterestComponent extends React.Component<IProps> {
  /**
   *
   */
  constructor(props: any) {
    super(props);
    this.ToggelInterests = this.ToggelInterests.bind(this);
  }

  public ToggelInterests(val: boolean) {
    this.props.doToggelUserIntrests(val);
  }

  public render() {
    const { userIntrests } = this.props;

    if (userIntrests && userIntrests.length > 0) {
      return (
        <div className="flex justify-between f5 ttu fw6">
          <div className="mr2">{this.props.label}</div>
          <Switch
            checked={this.props.isChecked}
            onChange={this.ToggelInterests}
          />
        </div>
      );
    }

    return null;
  }
}
function mapStateToProps(state: any, ownProps: any) {
  return {
    isChecked: UserSelector.isShowOnlyUserIntrests(),
    userIntrests: UserSelector.getUserInterests()
  };
}
function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    doToggelUserIntrests: (val: boolean) =>
      dispatch(toggelShowUserInterest(val))
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyPageShowUserInterestComponent);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/myPageShowInterests.component.tsx